import React, { useEffect, useState } from 'react';
import HomeMain from './HomeMain';
import Footer from '../../components/Layout/Footer';
import Header from '../../components/Layout/Header';
import BackToTop from '../../components/elements/BackToTop';
import HeaderStyleFour from '../../components/Layout/Header/HeaderStyleFour';
import FooterTwo from '../../components/Layout/Footer/FooterStyleTwo';
import SEOHelmet from '../../components/SEO/SEOHelmet';


const Home = () => {
    const [isVisible, setIsVisible] = useState(false);

    const handleScroll = () => {
        const scrollTop = window.scrollY;
        if (scrollTop > 300) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    useEffect(() => {
        window.addEventListener('scroll', handleScroll);
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
        <React.Fragment>
            <SEOHelmet 
                title="Scrap Processing & Recycling Equipment Solutions"
                description="Leading supplier of scrap shearing machines, shredders, magnets, grabbers, and complete recycling solutions. Serving industries worldwide."
                keywords="scrap processing, recycling equipment, shredder, scrap magnet, industrial recycling, container shear"
                canonicalUrl="https://ramanasteels.com/"
            />
            <HeaderStyleFour />
            <HomeMain />
            <BackToTop scroll={isVisible} />
            <FooterTwo />
            {/* <Footer /> */}
        </React.Fragment>
    );
}

export default Home;
